import lengthConfig from '../config/length';

import validateLength from './length';
import validateName from './name';

const validateSmartHomeName = (value: string, isAdmin: boolean): string => {
    const maxLength = lengthConfig.smartHomeName;
    if (value.length > maxLength) {
        return validateLength(value, maxLength, 'field-dialog-name');
    }
    return validateName(value, isAdmin, 'field-dialog-name');
};

export default validateSmartHomeName;
